import TOCMove from './tocMove';

const tocMoveConfig = {
  name: 'tocMove',
  class: TOCMove,
  querySelector: {
    controller: '.entry-sidebar',
    target: '.block--table-of-contents',
  },
};

export default tocMoveConfig;
